import { render, staticRenderFns } from "./refundreason.vue?vue&type=template&id=8618f662&scoped=true"
import script from "./refundreason.vue?vue&type=script&lang=js"
export * from "./refundreason.vue?vue&type=script&lang=js"
import style0 from "./refundreason.vue?vue&type=style&index=0&id=8618f662&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8618f662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8618f662')) {
      api.createRecord('8618f662', component.options)
    } else {
      api.reload('8618f662', component.options)
    }
    module.hot.accept("./refundreason.vue?vue&type=template&id=8618f662&scoped=true", function () {
      api.rerender('8618f662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/article/refundreason.vue"
export default component.exports